import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { formatearNumero } from "../../../helpers/funciones"
import { Boton, Spinner } from "asocomponents"
import { WEBURLEGALES } from "../../../helpers/frontend.js"
import { setResultadoGrilla } from "../../../redux/resultadoGrillaPagosSinFacturaSlice"
import PagosSinFacturaService from "../../../../modules/Liquidacion/application/PagosSinFacturaService.js"
import { resetIdLiquidacionSinFactura, resetPagoSinFactura, setIdLiquidacionSinFactura } from "../../../redux/datosPagoSinFacturaSlice.js"
import { useNavigate } from 'react-router-dom'

function GrillaPagoSinFactura() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  //Limpio el id de factura en caso de haber visualizado
  dispatch(resetPagoSinFactura())
  dispatch(resetIdLiquidacionSinFactura())

  //#region const
  const filtros = useSelector((state) => state.rootReducer.filtrosPagosSinFactura)

  const [isLoading, setIsLoading] = useState(false)
  const [resultado, setResultado] = useState([])
  const [existenRdos, setExistenRdos] = useState(true)

  //PARA EL PAGINADO
  const [paginaActual, setPaginaActual] = useState(1)
  const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

  //Recupero los filtros desde Redux que vienen desde FiltroEnfProfeionales.jsx
  const filtrosCargados = useSelector(state => state.rootReducer.filtrosPagosSinFactura.cargados)
  const filtroRapido = useSelector(state => state.rootReducer.filtrosPagosSinFactura.filtroRapido)

  //Estado para el menu desplegable de opciones sobre la grilla
  const [showMenuIndex, setShowMenuIndex] = useState(null) // Estado para almacenar el índice de la fila en la que se muestra el menú

  //#region effect

  useEffect(() => {
    fecthData(filtros)
  }, [filtrosCargados]) 

  useEffect(() => {
    if (filtroRapido !== '') {
      // Filtra los objetos en función del texto de búsqueda
      const resultadoFiltradoRapido = resultado.filter((obj) =>
        Object.values(obj).some((val) => val && val.toString().toLowerCase().includes(filtroRapido.toLowerCase())
        )
      )
      setResultado(resultadoFiltradoRapido)
      dispatch(setResultadoGrilla(resultadoFiltradoRapido))
    }
    else
      fecthData(filtros)

  }, [filtroRapido])

  //#endregion

  //#region paginado y fetchData
  const indiceUltimoElemento = paginaActual * elementosPorPagina
  const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
  let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

  const elementosPaginados =
    resultado === null
      ? []
      : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina)
  }

  const handleVerFactura = (idLiquidacion) => {
    dispatch(setIdLiquidacionSinFactura(idLiquidacion))
    navigate("/verFactura")
  }

  const fecthData = async (filtro) => {
    if (filtros.cuitLetrado) {
      setIsLoading(true)
      const facturaService = new PagosSinFacturaService()
      const result = await facturaService.getListPagos(
        filtro.idLiquidacionWeb,
        filtro.fechaVtoInicio,
        filtro.fechaVtoFin,
        filtro.fechaAltaInicio,
        filtro.fechaAltaFin,
        filtro.idJuicio,
        filtro.monImporteFacDesde,
        filtro.monImporteFacHasta,
        filtro.cuitLetrado
      )

      setExistenRdos(result.length > 0)
      setPaginaActual(1)
      setResultado(result)
      dispatch(setResultadoGrilla(result))
      setIsLoading(false)
    }
    setShowMenuIndex(false)
  }


  //#endregion

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div className="overflow-hidden">
      <div className="shadow-md sm:rounded-lg mr-2 ml-2">
        <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-[100%] ">
          <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
            <tr>
              <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                F. Reg.
              </th>
              <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                F. Vto
              </th>
              <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                Nro Recibo
              </th>
              <th scope="col" className="text-center  py-3" style={{ width: "35%" }}>
                Juicio
              </th>
              <th scope="col" className="text-center py-3" style={{ width: "15%" }}>
                Forma de Pago
              </th>
              <th scope="col" className="text-center py-3" style={{ width: "15%" }}>
                Importe
              </th>
              <th scope="col" className="text-center py-3"></th>
            </tr>
          </thead>
          <tbody>
            {elementosPaginados &&
              elementosPaginados.map((fac, index) => (
                <tr
                  className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                  key={fac.idLiquidacion}
                >
                  <td className="text-center py-2">{fac.fechaRegistroFormateada}</td>
                  <td className="text-center py-2">{fac.fechaVtoFormateada}</td>
                  <td className="text-center py-2">{fac.nroRecibo}</td>
                  <td className="text-center py-2">{fac.procesoJudicial}</td>
                  <td className="text-center py-2">{fac.formaPago}</td>
                  <td className="text-center py-2">$ {formatearNumero(String(fac.importe))}</td>
                  <td className="text-center py-2">
                    <div className="flex flex-row">
                      <Boton type="button" icono="eye" width="w-2" onClick={() => handleVerFactura(fac.idLiquidacion)} />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {!existenRdos &&
        <div className="flex flex-row items-center justify-center h-full">
          <div className="font-semibold text-lg text-center mb-4">
            No encontramos ningún registro para tu búsqueda
          </div>
          <div className="w-[300px] flex justify-center ml-40">
            <img src={`${WEBURLEGALES}/images/papers.svg`} alt="Sin resultados" />
          </div>
        </div>
      }
      <div className="col-span-2 flex justify-end items-center m-2">
        <span className="text-sm m-1">
          Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
        </span>
        <button
          className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
          onClick={() => cambiarPagina(paginaActual - 1)}
          disabled={paginaActual === 1}
        >
          {"<"}
        </button>
        <button
          className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
          onClick={() => cambiarPagina(paginaActual + 1)}
          disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
        >
          {">"}
        </button>
      </div>
    </div>
  )
}

export default GrillaPagoSinFactura